import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { AppHeadings } from 'src/app/configs/app-headings';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { FilterName } from 'src/app/configs/filter-names';
import { DataStoreService } from 'src/app/services/data-store.service';
import { ManageRecommendationsComponent } from '../manage-recommendations/manage-recommendations.component';
import { RoleCheckerService } from 'src/app/services/role-checker.service';

@Component({
  selector: 'app-link-vehicle',
  templateUrl: './link-vehicle.component.html',
  styleUrls: ['./link-vehicle.component.scss']
})

export class LinkVehicleComponent implements OnInit {

  searchForm: UntypedFormGroup;
  formError = {}
  formData: any = {};
  public processedLinkedData: any = {};
  public processingLinkedData: boolean = true;
  isDataReceived = false;
  isGettingRecommendVehicles: boolean = true;
  recommendedVehicles: any[] = [];

  isLoadingList: boolean = false;
  isPaging: boolean = false;
  vehicleList = [];
  noMoreRec = false;
  notFoundHeading = 'Please choose a filter.'
  notFoundDescription = ''
  vSubscription: Subscription
  vRecSubscription: Subscription
  total = 0
  currentTotal = 0
  page: any = 1
  limit = 10;
  selectedFilter = {}
  sort = 'asc'
  sortBy = 'new_price';
  alreadyAddedIds = [];
  loaderData = {
    loading: false,
    text: "Please wait while we are updating the linking."
  }
  loaderRecData = {
    loading: false,
    text: "Please wait while we are updating the linking."
  }
  filterState = {
    submit: false,
    reset: false,
    initialState: false,
    data: {},
    error: false,
    loader: true
  }
  type = ""
  getVehicleRec: Subscription;
  constructor(
    private fb: UntypedFormBuilder,
    public commonService: CommonService,
    private vehicleService: VehicleService,
    private filterName: FilterName,
    private dataStore: DataStoreService,
    public dialogObjRef: MatDialogRef<LinkVehicleComponent>,
    public dialog: MatDialog,
    public roleCheckService: RoleCheckerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //console.log('data', data)
    this.formData = data;
    this.searchForm = this.fb.group(
      {
        VFactsGroups: [''],
        Make: [''],
        Family: [''],
        Body_Type: [''],
        Fuel_Type: [''],
        Transmission: [''],
        Cylinders: [''],
        Vehicle_Level: ['']
      }
    )
    this.searchForm.valueChanges.subscribe(newVal => console.log(newVal));

    // check for vehicle action
    this.getVehicleRec = this.dataStore.getVehicleRec().subscribe(
      (data) => {
        this.handleRecomSignal(data)
      }
    )
  }

  ngOnInit() {
    ///this.getLinkedIds();
    // If we are on Accept/reject screen, we first need to check if vehicle is accepted or not.
    // If accepted load the adjustments history
    if (this.commonService.toggleIndex(this.formData.vehicle, 'toggle')) {
      this.fetchVehicleRecommendations();
    }
  }


  handleRecomSignal(data) {
    if (data['DatiumAssetKey']) {
      if (data['action'] == 'add') {
        if (data['record']) {
          const index = this.recommendedVehicles.findIndex(obj => obj.DatiumAssetKey == data['removeKey']);
          if (index == -1) {
            this.recommendedVehicles.push(data['record'])
          }
        }
      } else if (data['action'] == 'remove') {
        if (data['removeKey']) {
          const index = this.recommendedVehicles.findIndex(obj => obj.DatiumAssetKey == data['removeKey']);
          if (index != -1) {
            this.recommendedVehicles.splice(index, 1);
          }
        }
      }
    }
  }


  printChartData(data) {
    this.processedLinkedData = data;
    this.processingLinkedData = false;
  }

  /*
  * @name toggleLoader
  * @param None
  * @description toggle loader(pagination and other loader)
  * @return none
  */
  toggleLoader(show = false, paging = false) {
    if (paging == false) {
      this.isLoadingList = show
    } else {
      this.isPaging = show;
    }
  }

  /*
 * @name onScroll
 * @param newList:None
 * @description paginate on scroll
 * @return none
 */
  onScroll() {
    /*if (this.disableScroll === true) {
      return false;
    }*/
    if (this.isLoadingList === true || this.isPaging === true) {
      return false;
    }
    //console.log(typeof (this.page), 'this.page')
    let page = parseInt(this.page);
    this.page = page + 1;
    //console.log(typeof (this.page), 'this.page')
    if (this.currentTotal > 10) {
      //console.log('onScroll request')
      this.getVehicleList(true)
    }
  }

  searchResponse(response) {
    //console.log(response)
    //console.log(this.filterState, '---------------filter state')
    this.filterState = response
    if (this.filterState) {
      let filterStateChanges = this.filterState;
      //console.log(filterStateChanges, '-------------filterStateChanges')
      if (filterStateChanges) {//value == false
        let filterVal = filterStateChanges//.currentValue
        if (filterVal.submit == true) {
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
          //this.vehicleList = []
          //this.disableScroll = true;
          //this.page = 1
          //this.limit = 10;
          this.resetPaginationRecords()
          this.selectedFilter = this.filterState['data']//this.commonService.getInitialFilterApiParams(this.filterState['data'])
          this.getVehicleList()
        }
        if (filterVal.reset == true) {
          this.notFoundHeading = 'Please choose a filter.'
          this.notFoundDescription = ''
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
          this.resetPaginationRecords()
        }
        if (filterVal.error == true) {
          this.notFoundHeading = 'Please correct the errors.'
          this.notFoundDescription = ''
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
        }
      } else {
        let filterVal = filterStateChanges//.currentValue
        if (filterVal.error == true) {
          this.notFoundHeading = 'Please choose a filter.'
          this.notFoundDescription = ''
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
          this.isLoadingList = false;
        }
        if (filterVal.submit == true) {
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
          //this.vehicleList = []
          //this.disableScroll = true;
          //this.page = 1
          //this.limit = 10;
          this.resetPaginationRecords()
          this.selectedFilter = this.filterState['data']//this.commonService.getInitialFilterApiParams(this.filterState['data'])
          this.getVehicleList()
        }
        if (filterVal.reset == true) {
          this.notFoundHeading = 'Please choose a filter.'
          this.notFoundDescription = ''
          // cancel exiting request
          if (this.vSubscription != null) {
            // console.log('unsubscribe')
            this.vSubscription.unsubscribe();
          }
          this.resetPaginationRecords()
        }
      }
    }
    //console.log(this.filterState)
    //this.commonService.setLocalStorage('vehicle_filters', JSON.stringify(response.data))
    //this.commonService.sendUserTo('vehicle-list-bi')
  }

  /*
 * @name handleSearchForm
 * @param searchFormObj:FormGroup
 * @description handle the search form
 * @return none
 */
  handleSearchForm(searchFormObj: UntypedFormGroup) {
    //console.log(searchFormObj, searchFormObj.valid)
    if (searchFormObj.valid) {
      let VFactsGroups = searchFormObj.value.VFactsGroups
      let Make = searchFormObj.value.Make
      if (!VFactsGroups && !Make) {
        if (!VFactsGroups) {
          return this.handleServerFormError({
            'VFactsGroups': 'Please choose VFacts Groups.'
          })
        }
        if (!Make) {
          return this.handleServerFormError({
            'Make': 'Please choose Make.'
          })
        }
      }
      this.resetPaginationRecords()
      this.getVehicleList();
    } else {
      this.formValidate(searchFormObj);
    }
  }

  /*
  * @name resetPaginationRecords
  * @param None
  * @description reset pagination, records and selected filter
  * @return none
  */
  resetPaginationRecords() {
    this.page = 1
    this.limit = 10
    this.total = 0
    this.currentTotal = 0
    this.vehicleList = [];
    this.sort = 'asc'
    this.sortBy = 'new_price'
    //this.disableScroll = true;
    this.noMoreRec = false;
    this.isLoadingList = false;
    this.isPaging = false
  }

  /*
  * @name resetFilters
  * @param none
  * @description reset the vehicle filter form
  * @return none
  */
  resetFilters() {
    this.searchForm.setValue(this.filterName.filter)
    this.formError = {}
    this.vehicleList = [];
    this.dataStore.setSelectedFilters(this.filterName.filter)
    this.dataStore.resetVehicleFilterList()
  }

  /*
  * @name getLinkedIds
  * @param None
  * @description get all linked vehicle ids(Admin and company user)
  * @return none
  */
  getLinkedIds() {
    this.vehicleService.getLinkedVehicleIds().subscribe(
      (result: any) => {
        try {
          let response = result;
          let vehicleData = response.data;
          this.alreadyAddedIds = vehicleData.ids
        } catch (e) {

        }
      },
      (error) => {
        //console.log(error)
        let response = error;
        if (response.message) {
          //this.handleServerFormError(response.errors)
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
      },
      () => {
      }
    )
  }

  /*
  * @name changeVehicle
  * @param None
  * @description receive signal for adding/updating the linking
  * @return none
  */
  changeVehicle(data, rec = false) {
    this.commonService.showSnakeBar('Please wait while we are updating the linking.');
    if (rec == false) {
      this.loaderData.loading = true
    } else {
      this.loaderRecData.loading = true
    }
    let child = data['child']
    let parent = data['parent']
    this.vehicleService.changeVehicleLinking(child, parent).subscribe(
      (result: any) => {
        try {
          if (rec == false) {
            this.loaderData.loading = false
          } else {
            this.loaderRecData.loading = false
          }
          let response = result;
          this.commonService.showSnakeBar(response.message);
          //console.log(child, 'child')
          this.dataStore.resetVehicleDetailsReload(child, true, true)
          this.dialogObjRef.close()
        } catch (e) {

        }
      },
      (error) => {
        //console.log(error)
        if (rec == false) {
          this.loaderData.loading = false
        } else {
          this.loaderRecData.loading = false
        }
        let response = error;
        if (response.message) {
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
      },
      () => {

      }
    )
  }

  /*
  * @name getVehicleList
  * @param None
  * @description Api call for fetching the vehicle list
  * @return none
  */
  getVehicleList(paging = false) {
    this.toggleLoader(true, paging)
    let apiParams = {
      page: this.page,
      limit: this.limit,
      sort: this.sort,
      sortBy: this.sortBy,
      type: 'bi',
      exId: ''
    }
    if (this.formData['linkedVehicle']) {
      if ('DatiumAssetKey' in this.formData['linkedVehicle']) {
        apiParams['exId'] = this.formData.linkedVehicle.DatiumAssetKey
      }
    }
    apiParams = Object.assign(apiParams, this.selectedFilter)
    apiParams['list_type'] = 'link_list'
    if (this.vSubscription != null) {
      this.vSubscription.unsubscribe();
    }
    this.vSubscription = this.vehicleService.otherVehicleListing(apiParams, 'post').subscribe(
      (result: any) => {
        try {
          let response = result;
          let vehicleData = response.data;
          if (this.page == 1) {
            this.total = vehicleData.total
          }
          this.currentTotal = vehicleData.total
          //this.total = vehicleData.total
          this.limit = vehicleData.limit
          this.page = vehicleData.page
          if (this.currentTotal == 0 && paging === true) {
            this.noMoreRec = true;
          } else {
            this.noMoreRec = false;
          }
          if (vehicleData.records.length > 0) {
            this.appendVehicleListing(vehicleData.records)
          } else {
            if (this.page == 1) {
              this.notFoundHeading = 'Hum.. Looks like no record(s) found for this filter'
              this.notFoundDescription = 'Please update your filter above.'
            }
          }
        } catch (e) {

        }
      },
      (error) => {
        let response = error;
        this.toggleLoader(false, paging)
        if (response.message) {
          this.handleServerFormError(response.errors)
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
        if (this.page != 1) {
          this.page -= 1
        }
      },
      () => {
        this.toggleLoader(false, paging)
      }
    )
  }


  /*
  * @name appendVehicleListing
  * @param newList:Array
  * @description paginate over vehicle listing                   
  * @return none
  */
  appendVehicleListing(newList = []) {
    if (newList.length > 0) {
      let newState = [];
      if (this.vehicleList.length > 0) {
        newState = this.vehicleList.slice();
      }
      newList.forEach(element => {
        newState.push(element)
      });
      this.vehicleList = newState
    }

  }

  /*
    * @name formValidate
    * @param  Form
    * @description validate form                       
    * @return none
    */
  formValidate(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.formValidate(control);
      }
    });
  }

  /*
  * @name handleServerFormError
  * @param Form
  * @description handle server side errors                  
  * @return none
  */
  handleServerFormError(errors) {
    if (Object.keys(errors).length > 0) {
      Object.keys(errors).forEach((key) => {
        //console.log(key, this.searchForm.contains(key))
        if (this.searchForm.contains(key)) {
          let control = this.searchForm.get(key);
          control.markAsTouched({ onlySelf: true });
          control.setErrors({ 'incorrect': true })
          this.formError[key] = errors[key];
          //console.log(this.formError, control)
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.vSubscription) {
      this.vSubscription.unsubscribe()
    }
    if (this.vRecSubscription) {
      this.vRecSubscription.unsubscribe()
    }
    if (this.getVehicleRec) {
      this.getVehicleRec.unsubscribe()
    }
  }

  fetchVehicleRecommendations() {
    let exId = ''
    if (this.formData['linkedVehicleId'] != undefined) {
      exId = this.formData['linkedVehicleId']
    }
    this.vRecSubscription = this.vehicleService.getVehicleRecommendations(this.formData.vehicleId, exId).subscribe((result: any) => {
      try {
        const response = result;
        this.recommendedVehicles = response.data;
      } catch (e) {

      }
      this.isGettingRecommendVehicles = false;
    },
      (error) => {
        //console.log(this.recommendedVehicles, error);
        this.isGettingRecommendVehicles = false
        try {
          let response = error;
          if (response.message) {
            this.handleServerFormError(response.errors)
            this.commonService.showSnakeBar(response.message);
          } else {
            this.commonService.commonSnakeBar();
          }
        } catch (e) {

        }
      },
      () => {
        this.isGettingRecommendVehicles = false
      })
  }


  linkingRecommendations(): void {
    const dialogRef = this.dialog.open(ManageRecommendationsComponent, {
      width: 'auto',
      height: 'auto',
      data: {
        linkedVehicle: this.formData['linkedVehicle'],
        vehicle: this.formData['vehicle'],
        vehicleId: this.formData['vehicleId']
      },
      disableClose: true
    });
  }
}
